import React, { createContext, ReactNode } from 'react';
import { useFirebaseTrips } from '../hooks/useFirebaseTrips';
import { Trip } from '../types';

interface FirebaseTripsContextType {
  trips: Trip[];
  sharedTrips: Trip[];
  allTrips: Trip[];
  isLoading: boolean;
  error: string | null;
  createTrip: (tripData: Omit<Trip, 'id' | 'createdAt' | 'updatedAt'>) => Promise<string>;
  updateTrip: (tripId: string, updates: Partial<Trip>) => Promise<void>;
  deleteTrip: (tripId: string) => Promise<void>;
  shareTrip: (tripId: string, email: string) => Promise<void>;
  refreshTrips: () => Promise<void>;
}

export const FirebaseTripsContext = createContext<FirebaseTripsContextType | undefined>(undefined);

export function FirebaseTripsProvider({ children }: { children: ReactNode }) {
  const trips = useFirebaseTrips();

  return (
    <FirebaseTripsContext.Provider value={trips}>
      {children}
    </FirebaseTripsContext.Provider>
  );
}